// Theme Configuration - Your Custom Colors
const theme = {
  colors: {
    navDivider: "#E5E7EB",
    blue1: "#0D99FF",
    blue2: "#e8f2ff",
    green1: "#109478",
    green2: "#EBFFF1",
    grey1: "#9CA3AF",
    grey2: "#E5E7EB",
    grey3: "#F9FAFB",
    grey4: "#FDFDFD",
    grey5: "#ebedef",
    yellow1: "#FDC448",
    yellow2: "#FFDB56",
    yellow3: "#fff7dd",
    yellow4: "#C98914",
    purple1: "#AF52DE",
    purple2: "#F5EFF7",
    red1: "#FF3B30",
  },
};

export default theme;
